module.exports = "<dbm-list [aggregationList]=\"true\" [listTitle]=\"'Rule List'\"\n          [listAction]=\"'Add Rule'\" [listSearchPlaceholder]=\"'Search Rule'\"\n          [listItems]=\"rules\" [listItemIcon]=\"'user-icon'\"\n          (onActionClick)=\"onAddRule.emit()\" (onListItemClick)=\"getRule($event.selectedItem, $event.indexInList)\">\n</dbm-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/policyEngine/rules-management/rule-list/rule-list.component.html
// module id = 1772
// module chunks = 0